var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "card p-3 mb-4" },
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { md: "8" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center mb-2" },
                  [
                    _c("h2", { staticClass: "mb-0 mr-3" }, [
                      _vm._v("Proposta " + _vm._s(_vm.proposta.id || "Nova"))
                    ]),
                    _vm._v(" "),
                    _vm.proposta.status == "CANCELADO"
                      ? _c(
                          "b-badge",
                          { staticClass: "p-2", attrs: { variant: "danger" } },
                          [
                            _c("i", {
                              staticClass: "fas fa-times-circle mr-1"
                            }),
                            _vm._v(" Proposta Cancelada\n          ")
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "text-muted" }, [
                  _vm._v(
                    "Preencha os dados abaixo para criar ou editar a proposta."
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right total-display", attrs: { md: "4" } },
                [
                  _c("label", { staticClass: "text-muted mb-0" }, [
                    _vm._v("TOTAL DA PROPOSTA BRUTO")
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    { staticClass: "text-primary font-weight-bold mb-0" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatCurrency(_vm.showValorSubtotal)) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.proposta.tipo_bonificacao == "BRINDE"
                    ? _c("h6", { staticClass: "text-danger mt-1" }, [
                        _vm._v(
                          "\n          Saldo Bruto Brinde: " +
                            _vm._s(
                              _vm.formatCurrency(_vm.getSaldoBrindeBruto)
                            ) +
                            " / Saldo Liquido Brinde: " +
                            _vm._s(_vm.formatCurrency(_vm.getSaldoBrinde)) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "mb-4", attrs: { "no-body": "" } },
        [
          _c("b-card-header", { attrs: { "header-tag": "header" } }, [
            _c("h5", { staticClass: "mb-0" }, [
              _c("i", { staticClass: "fas fa-file-alt mr-2" }),
              _vm._v("Informações Gerais")
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Tipo da Proposta",
                            "label-for": "tipo-proposta"
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "tipo-proposta",
                              options: _vm.getListaTipoProposta,
                              disabled:
                                _vm.role == "preposto" ||
                                _vm.readonly ||
                                _vm.proposta.id != null
                            },
                            on: { change: _vm.changePrazoPagamento },
                            model: {
                              value: _vm.proposta.tipo_proposta,
                              callback: function($$v) {
                                _vm.$set(_vm.proposta, "tipo_proposta", $$v)
                              },
                              expression: "proposta.tipo_proposta"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Selecione um Cliente / Lead",
                            "label-for": "select-cliente"
                          }
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "select-cliente",
                              options: _vm.listaProspecto,
                              disabled: _vm.readonly || _vm.proposta.id != null,
                              placeholder: "Digite para buscar..."
                            },
                            on: {
                              search: _vm.buscaLead,
                              change: _vm.selectProspecto
                            },
                            model: {
                              value: _vm.prospecto,
                              callback: function($$v) {
                                _vm.prospecto = $$v
                              },
                              expression: "prospecto"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.proposta.tipo_proposta == "BONIFICACAO"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Classificação da Bonificação",
                                "label-for": "classificacao-bonificacao",
                                description: _vm.showAprovarButton
                                  ? "Revise a classificação antes de aprovar."
                                  : ""
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "classificacao-bonificacao",
                                  options: _vm.optionsClassificacaoBonificacao,
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value: _vm.proposta.classificacao_bonificacao,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.proposta,
                                      "classificacao_bonificacao",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "proposta.classificacao_bonificacao"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "fieldset",
        { attrs: { disabled: !_vm.prospecto || _vm.readonly } },
        [
          _c(
            "b-card",
            { staticClass: "mb-4", attrs: { "no-body": "" } },
            [
              _c("b-card-header", { attrs: { "header-tag": "header" } }, [
                _c("h5", { staticClass: "mb-0" }, [
                  _c("i", { staticClass: "fas fa-dollar-sign mr-2" }),
                  _vm._v("Condições Comerciais")
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-card-body",
                [
                  _c(
                    "b-row",
                    [
                      _vm.proposta.tipo_proposta == "VENDA" ||
                      _vm.proposta.tipo_proposta == "BONIFICACAO"
                        ? _c(
                            "b-col",
                            { attrs: { md: "6", lg: "4" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Desconto (%)" } },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { disabled: _vm.readonly },
                                      on: {
                                        change: function($event) {
                                          _vm.processarPromotions(),
                                            _vm.removeBrindes()
                                        }
                                      },
                                      model: {
                                        value: _vm.proposta.desconto,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.proposta,
                                            "desconto",
                                            $$v
                                          )
                                        },
                                        expression: "proposta.desconto"
                                      }
                                    },
                                    _vm._l(_vm.optionsDescontos, function(
                                      option
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: option.value,
                                          attrs: { disabled: option.disabled },
                                          domProps: { value: option.value }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(option.text) +
                                              "\n                  "
                                          ),
                                          option.disabled
                                            ? _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        option.text_disabled
                                                      ) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.proposta.tipo_proposta == "VENDA" &&
                      _vm.canBonif &&
                      _vm.getClassProspecto != "F"
                        ? _c(
                            "b-col",
                            { attrs: { md: "6", lg: "4" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Bonificação (%)" } },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "form-control",
                                      attrs: { disabled: _vm.readonly },
                                      on: {
                                        change: function($event) {
                                          return _vm.removeBrindes()
                                        }
                                      },
                                      model: {
                                        value: _vm.proposta.bonificacao,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.proposta,
                                            "bonificacao",
                                            $$v
                                          )
                                        },
                                        expression: "proposta.bonificacao"
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v("Sem Bonificação")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "5" } }, [
                                        _vm._v("5 %")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "10" } }, [
                                        _vm._v("10 %")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.proposta && _vm.proposta.bonificacao > 0
                        ? _c(
                            "b-col",
                            { staticClass: "mt-2 mb-3", attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Tipo de Bonificação" } },
                                [
                                  !_vm.readonly
                                    ? _c("b-form-radio-group", {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          options: _vm.optionsTipo,
                                          buttons: "",
                                          "button-variant": "outline-primary",
                                          size: "sm"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.removeBrindes()
                                          }
                                        },
                                        model: {
                                          value: _vm.proposta.tipo_bonificacao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.proposta,
                                              "tipo_bonificacao",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "proposta.tipo_bonificacao"
                                        }
                                      })
                                    : _c(
                                        "b-badge",
                                        { attrs: { variant: "primary" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.proposta.tipo_bonificacao
                                            )
                                          )
                                        ]
                                      )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.proposta.tipo_proposta == "VENDA"
                        ? _c(
                            "b-col",
                            { attrs: { md: "6", lg: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "prazo-medio",
                                  attrs: {
                                    label: "Prazo Pagamento",
                                    "invalid-feedback": _vm.getPrazoMedio,
                                    state: false
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      disabled: _vm.readonly,
                                      options:
                                        _vm.proposta.tipo_proposta ==
                                          "BONIFICACAO" ||
                                        _vm.proposta.tipo_proposta == "AMOSTRA"
                                          ? _vm.showPrazosPagamento
                                          : _vm.proposta.id &&
                                            _vm.proposta.id <= 357
                                          ? _vm.showPrazosPagamento
                                          : _vm.optionsPrazo
                                    },
                                    model: {
                                      value: _vm.proposta.prazo_pagamento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.proposta,
                                          "prazo_pagamento",
                                          $$v
                                        )
                                      },
                                      expression: "proposta.prazo_pagamento"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.proposta.tipo_proposta == "VENDA"
                        ? _c(
                            "b-col",
                            { attrs: { md: "6", lg: "4" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Vencimento da Proposta" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      disabled: _vm.readonly,
                                      type: "date"
                                    },
                                    model: {
                                      value: _vm.proposta.vencimento_proposta,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.proposta,
                                          "vencimento_proposta",
                                          $$v
                                        )
                                      },
                                      expression: "proposta.vencimento_proposta"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.proposta.tipo_proposta == "VENDA"
                        ? _c(
                            "b-col",
                            { attrs: { md: "6", lg: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: "Ordem de Compra (Opcional)" }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["####################"],
                                        expression: "['####################']"
                                      }
                                    ],
                                    attrs: { disabled: _vm.readonly },
                                    model: {
                                      value: _vm.proposta.ordem_compra,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.proposta,
                                          "ordem_compra",
                                          $$v
                                        )
                                      },
                                      expression: "proposta.ordem_compra"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-2", attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Observações da Proposta" } },
                            [
                              _c("b-form-textarea", {
                                attrs: {
                                  disabled: _vm.readonly,
                                  placeholder:
                                    "Digite aqui alguma observação importante...",
                                  rows: "4",
                                  "no-resize": ""
                                },
                                model: {
                                  value: _vm.proposta.obs,
                                  callback: function($$v) {
                                    _vm.$set(_vm.proposta, "obs", $$v)
                                  },
                                  expression: "proposta.obs"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            { staticClass: "mb-4", attrs: { "no-body": "" } },
            [
              _c("b-card-header", { attrs: { "header-tag": "header" } }, [
                _c("h5", { staticClass: "mb-0" }, [
                  _c("i", { staticClass: "fas fa-box mr-2" }),
                  _vm._v("Itens da Proposta")
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-card-body",
                [
                  !_vm.readonly
                    ? _c("busca-produto", {
                        staticClass: "mb-2",
                        attrs: {
                          title: "Adicionar produto à proposta",
                          listaProdutos: _vm.listaProdutos,
                          item: _vm.item,
                          brinde:
                            _vm.proposta.tipo_bonificacao == "BRINDE"
                              ? true
                              : false
                        },
                        on: { addProduto: _vm.addProduto }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readonly
                    ? _c(
                        "div",
                        { staticClass: "text-right mb-4" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-primary", size: "sm" },
                              on: {
                                click: function($event) {
                                  _vm.modalImportarPlanilha = true
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-file-excel mr-1"
                              }),
                              _vm._v(" Importar Planilha\n          ")
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-table", {
                    key: _vm.itensTableKey,
                    attrs: {
                      items: _vm.itens,
                      fields: _vm.headerItens,
                      striped: "",
                      small: "",
                      hover: "",
                      "foot-clone": "",
                      responsive: "",
                      "show-empty": "",
                      "empty-text": "Nenhum item adicionado à proposta."
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(produto_id)",
                        fn: function(data) {
                          return [
                            !_vm.readonly
                              ? _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    attrs: {
                                      disabled:
                                        data.item.promocao &&
                                        data.item.promocao.bloquear,
                                      variant: "outline-danger",
                                      size: "sm",
                                      title: "Remover Item"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeItem(data.index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-trash" })]
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell(produto)",
                        fn: function(data) {
                          return [
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(data.item.produto.codigo))
                              ]),
                              _vm._v(
                                " - " +
                                  _vm._s(data.item.produto.descricao) +
                                  "\n              "
                              ),
                              data.item.promocao
                                ? _c(
                                    "div",
                                    { staticClass: "mt-1" },
                                    [
                                      _c(
                                        "b-badge",
                                        { attrs: { variant: "success" } },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-tags mr-1"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                data.item.promocao.descricao
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]
                        }
                      },
                      {
                        key: "cell(valor_unitario)",
                        fn: function(row) {
                          return [
                            row.item.produto.preco_regular &&
                            row.item.produto.preco_regular > 0 &&
                            row.item.produto.preco_venda <
                              row.item.produto.preco_regular
                              ? _c("div", [
                                  _c(
                                    "small",
                                    {
                                      staticClass: "text-danger",
                                      staticStyle: {
                                        "text-decoration": "line-through"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formatCurrency(
                                              parseFloat(
                                                row.item.produto.preco_regular
                                              )
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatCurrency(
                                    parseFloat(row.item.valor_unitario)
                                  )
                                ) +
                                "\n            "
                            ),
                            row.item.valor_unitario_tabela &&
                            parseFloat(row.item.valor_unitario) >
                              parseFloat(row.item.valor_unitario_tabela)
                              ? _c("div", [
                                  _c("small", { staticClass: "text-success" }, [
                                    _vm._v(
                                      "\n                Tabela: " +
                                        _vm._s(
                                          _vm.formatCurrency(
                                            parseFloat(
                                              row.item.valor_unitario_tabela
                                            )
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "foot(produto_id)",
                        fn: function() {
                          return undefined
                        },
                        proxy: true
                      },
                      {
                        key: "foot(produto)",
                        fn: function() {
                          return undefined
                        },
                        proxy: true
                      },
                      {
                        key: "foot(quantidade)",
                        fn: function() {
                          return [
                            _c("strong", { staticClass: "text-right" }, [
                              _vm._v("TOTAIS")
                            ])
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "foot(valor_unitario)",
                        fn: function() {
                          return [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.formatCurrency(_vm.totalAmountUnit))
                              )
                            ])
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "foot(valor_desconto)",
                        fn: function() {
                          return [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(_vm.totalAmountDesconto)
                                )
                              )
                            ])
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "foot(valor_total)",
                        fn: function() {
                          return [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.formatCurrency(_vm.totalAmount))
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c("b-card-header", [
            _c("h5", { staticClass: "mb-0" }, [
              _c("i", { staticClass: "fas fa-tasks mr-2" }),
              _vm._v("Resumo e Ações")
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c("b-col", { attrs: { md: "6" } }, [
                    _c("div", { staticClass: "list-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "list-group-item d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v("\n              Valor Bruto\n              "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              _vm._s(_vm.formatCurrency(_vm.showValorSubtotal))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "list-group-item d-flex justify-content-between align-items-center"
                        },
                        [
                          _vm._v(
                            "\n              Valor Desconto\n              "
                          ),
                          _c(
                            "span",
                            { staticClass: "font-weight-bold text-danger" },
                            [
                              _vm._v(
                                "- " +
                                  _vm._s(
                                    _vm.formatCurrency(_vm.showValorDesconto)
                                  )
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "list-group-item active d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("h5", { staticClass: "mb-0 text-white" }, [
                            _vm._v("Valor Líquido")
                          ]),
                          _vm._v(" "),
                          _c(
                            "h5",
                            { staticClass: "mb-0 font-weight-bold text-white" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(
                                    _vm.showValorTotalComDesconto
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { md: "6" } },
                    [
                      _vm.proposta && parseInt(_vm.proposta.id) > 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { variant: "light" },
                              on: { click: _vm.imprimir }
                            },
                            [
                              _c("i", { staticClass: "fa fa-print" }),
                              _vm._v(" Imprimir\n          ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "secondary",
                            href: "/venda-direta/propostas"
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-arrow-left" }),
                          _vm._v(" Voltar\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.showAprovarButton
                        ? _c(
                            "b-button",
                            {
                              staticClass: "ml-2",
                              attrs: { variant: "warning" },
                              on: { click: _vm.aprovarProposta }
                            },
                            [
                              _c("i", { staticClass: "fas fa-check" }),
                              _vm._v(" Aprovar Proposta\n          ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.proposta.status === "ABERTO"
                        ? _c(
                            "b-button",
                            {
                              staticClass: "ml-2",
                              attrs: { variant: "primary" },
                              on: { click: _vm.saveProposta }
                            },
                            [
                              _c("i", { staticClass: "fas fa-save" }),
                              _vm._v(" Salvar Proposta\n          ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.validationGerarPedido
                        ? _c(
                            "b-button",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                variant: "success",
                                disabled: _vm.pedido_gerado
                              },
                              on: { click: _vm.GerarPedido }
                            },
                            [
                              _c("i", { staticClass: "fas fa-box-open" }),
                              _vm._v(" Gerar Pedido\n          ")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-modal", {
        attrs: { title: "Copia e Cola", size: "lg" },
        model: {
          value: _vm.modalCopiaCola,
          callback: function($$v) {
            _vm.modalCopiaCola = $$v
          },
          expression: "modalCopiaCola"
        }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Importar Planilha", size: "lg" },
          on: { hidden: _vm.resetImportarPlanilha },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function($event) {
                          _vm.modalImportarPlanilha = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled:
                          !_vm.arquivoImportacao || _vm.loadingImportacao
                      },
                      on: { click: _vm.importarPlanilha }
                    },
                    [
                      _vm.loadingImportacao
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" Importar\n      ")
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalImportarPlanilha,
            callback: function($$v) {
              _vm.modalImportarPlanilha = $$v
            },
            expression: "modalImportarPlanilha"
          }
        },
        [
          _c("p", [
            _vm._v(
              "\n      Envie uma planilha (XLS, XLSX ou CSV) com as colunas "
            ),
            _c("strong", [_vm._v("Produto")]),
            _vm._v(", "),
            _c("strong", [_vm._v("Quantidade")]),
            _vm._v('\n      (ou "Qtd") e, opcionalmente, '),
            _c("strong", [_vm._v("Preço")]),
            _vm._v(
              ". O nome das colunas não diferencia maiúsculas/minúsculas.\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted small" }, [
            _vm._v(
              "\n      A coluna Produto deve conter o código do produto. Se a coluna Preço não for informada (ou vier vazia em\n      alguma linha), será usado o preço de tabela. Um preço abaixo do valor de tabela será rejeitado.\n    "
            )
          ]),
          _vm._v(" "),
          _c("b-form-file", {
            attrs: {
              accept: ".xlsx,.xls,.csv",
              placeholder: "Escolha um arquivo...",
              "drop-placeholder": "Solte o arquivo aqui..."
            },
            model: {
              value: _vm.arquivoImportacao,
              callback: function($$v) {
                _vm.arquivoImportacao = $$v
              },
              expression: "arquivoImportacao"
            }
          }),
          _vm._v(" "),
          _vm.importacaoResultado
            ? _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _vm.importacaoResultado.sucesso.length > 0
                    ? _c(
                        "b-alert",
                        { attrs: { show: "", variant: "success" } },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.importacaoResultado.sucesso.length) +
                              " produto(s) importado(s) com sucesso.\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.importacaoResultado.erros.length > 0
                    ? _c(
                        "b-alert",
                        { attrs: { show: "", variant: "warning" } },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.importacaoResultado.erros.length) +
                                " linha(s) com problema:"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "mb-0" },
                            _vm._l(_vm.importacaoResultado.erros, function(
                              erro,
                              index
                            ) {
                              return _c("li", { key: index }, [
                                _vm._v(_vm._s(erro))
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a893700", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a893700","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/propostas/create-proposta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2a893700","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/propostas/create-proposta.vue
// module chunks = 2